'use strict';

export const tabConstants = Object.freeze({
  TAB: ['formula', 'manual_price_card'],
});
